import { Check, Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string;
  description: string;
  onClose: (confirmed: boolean) => void;
  open: boolean;
} & DialogProps;

export const ConfirmationDialog = ({ title, description, onClose, open, ...other }: Props) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }} maxWidth="xs" open={open} {...other}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>{description}</DialogContent>
      <DialogActions>
        <Button startIcon={<Close />} onClick={handleCancel} variant={'outlined'} color={'warning'}>
          {t('cancel')}
        </Button>
        <Button startIcon={<Check />} onClick={handleOk} variant={'outlined'}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
